import { State } from '@app/store/state';
import { memoize } from 'proxy-memoize';

export const selectOrganizationInfo = (state: State) =>
  state.organization.organizationInfo;

export const selectOrganizationName = (state: State) =>
  state.organization.organizationInfo.name;

export const selectOrganizationAbout = (state: State) =>
  state.organization.organizationInfo.about;

export const selectOrganizationEmail = (state: State) =>
  state.organization.organizationInfo.email;

export const selectOrganizationProfilePicture = (state: State) =>
  state.organization.organizationInfo.image;

export const selectOrganizationSocials = memoize((state: State) => ({
  facebookUrl: state.organization.organizationInfo.facebookUrl,
  linkedinUrl: state.organization.organizationInfo.linkedinUrl,
  twitterUrl: state.organization.organizationInfo.twitterUrl,
  websiteUrl: state.organization.organizationInfo.websiteUrl,
}));

export const selectOrganizationProfileStatus = (state: State) =>
  state.organization.profileUpdate.status;

export const selectOrganizationProfileFieldErrors = (state: State) =>
  state.organization.profileUpdate.fieldErrors;

export const selectOrganizationFeatures = (state: State) =>
  state.organization.organizationInfo.features;

export const selectOrganizationPaymentPlan = (state: State) =>
  state.organization.organizationInfo.paymentPlan;

export const selectOrganizationError = (state: State) =>
  state.organization.organizationInfo.error;

export const selectOrganizationStatus = (state: State) =>
  state.organization.organizationInfo.status;

export const selectOrganizationEvents = (state: State) =>
  state.organization.organizationEvents;

export const selectOrganizationSeries = (state: State) =>
  state.organization.organizationSeries;

export const selectOrganizationPaymentPlanName = (state: State) =>
  state.organization.organizationInfo.paymentPlan.planName;

export const selectOrganizationPaymentPlanEndsAt = (state: State) =>
  state.organization.organizationInfo.paymentPlan.endsAt;
export const selectCreateSeriesModalEvents = (state: State) =>
  state.organization.createSeriesModal.eventIds;

export const selectCreateSeriesModalPageInfo = (state: State) =>
  state.organization.createSeriesModal.pageInfo;

export const selectCreateSeriesModalEventFetchStatus = (state: State) =>
  state.organization.createSeriesModal.status;

export const selectCreateSeriesModalEventSearchText = (state: State) =>
  state.organization.createSeriesModal.eventSearchText;

export const selectAddSeriesToEventModalEvents = (state: State) =>
  state.organization.addSeriesToEvent.seriesList;

export const selectAddSeriesToEventModalPageInfo = (state: State) =>
  state.organization.addSeriesToEvent.pageInfo;

export const selectAddSeriesToEventModalStatus = (state: State) =>
  state.organization.addSeriesToEvent.status;

export const selectAddSeriesToEventModalEventSearchText = (state: State) =>
  state.organization.addSeriesToEvent.searchText;

export const selectAddSeriesToEventModalPinEvent = (state: State) =>
  state.organization.addSeriesToEvent.pinEvent;

export const selectOrganizationLatestEndedEvents = (state: State) =>
  state.organization.organizationLatestEndedEvents.items;

export const selectOrganizationEventsHasRecordingsMap = (state: State) =>
  state.organization.organizationEventsHasRecordings.hasRecordingsMap;

export const selectOrganizationEventHasRecording =
  (eventId: string) => (state: State) =>
    Boolean(
      state.organization.organizationEventsHasRecordings.hasRecordingsMap[
        eventId
      ],
    );

export const selectOrganizationEventLongestRecording =
  (eventId: string) => (state: State) =>
    state.organization.organizationLatestEndedEventsRecordings.recordingsMap[
      eventId
    ];

export const selectShowEventDuplicateNotAllowedModal = (state: State) =>
  state.organization.showEventDuplicateNotAllowedModal;

export const selectIsAiDisabled = (state: State): boolean => {
  const settings = state.organization.organizationInfo.settings;
  return settings?.disableAiFeatures ?? false;
};

export const selectOrgSpaces = (state: State) =>
  state.organization.orgSpaces.spaces;

export const selectFirstSpaceData = (state: State) =>
  state.organization.orgSpaces.spaces[0];

export const isFirstSpaceLoading = (state: State) =>
  state.organization.orgSpaces.spaces.length === 0 &&
  state.organization.orgSpaces.status === 'processing';

export const selectOrgSpacesStatus = (state: State) =>
  state.organization.orgSpaces.status;

export const selectOrgSpacesPageInfo = (state: State) =>
  state.organization.orgSpaces.pageInfo;

export const selectOrgSpacesFeatureFlagEnabled = (state: State) =>
  state.organization.spacesFeatureFlagEnabled;

export const selectCurrentSpace = (state: State) =>
  state.organization.currentSpace;

export const selectCurrentSpaceExternalId = (state: State) =>
  state.organization.currentSpace.id;

export const selectInitialSpaceIdResolved = (state: State) =>
  state.organization.initialSpaceIdResolved;

export const selectInvalidSpaceAccessModal = (state: State) =>
  state.organization.invalidSpaceAccessModal;
